import { useIntl } from 'react-intl';

const PrintHeader = ({ header }: { header: string }) => {
  const intl = useIntl();
  return <div className="font-bold text-blue mb-2 text-base">{intl.formatMessage({ id: header })}</div>;
};
export default PrintHeader;
